import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CurrentDataPage.css';

function CurrentDataPage({ selectedCrop }) {
  // Example data for the current data
  const currentData = [
    { month: "January", year: 2026, areaofland: 5000},
    { month: "February", year: 2026, areaofland: 4800},
    { month: "March", year: 2026, areaofland: 3200},
    { month: "April", year: 2026, areaofland: 3500},
    { month: "May", year: 2026, areaofland: 4200},
    { month: "June", year: 2026, areaofland: 4650 }
    // Add more data for other years here
  ];

  const navigate = useNavigate();

  const handleNextClick = () => {
    navigate('/form');
  }

  return (
    <div className="current-data-page">
      <h2 style={{fontSize:"45px", color:"black"}}>Current Year Data for {selectedCrop}</h2>
      <table className='styled-table'>
        <thead>
          <tr>
            <th style={{fontSize: "25px", fontStyle: "bold", textAlign: "left"}}>Month and Year of plantation</th>
            <th style={{fontSize: "25px", fontStyle: "bold", textAlign: "left"}}>Area of land (in acres)</th>
          </tr>
        </thead>
        <tbody>
          {currentData.map((entry, index) => (
            <tr key={index}>
              <td style={{fontSize: "20px", textAlign: "left"}}>{entry.month}, {entry.year}</td>
              <td style={{fontSize: "20px", textAlign: "left"}}>{entry.areaofland}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button id="next-button" onClick={handleNextClick}>Next</button>
    </div>
  );
}

export default CurrentDataPage;
